import _ from "lodash"
import store from "store"
export default class Analytics {
   constructor() {
      this.viewQueue = store.get("viewQueue") || []
   }

   push(product) {
      this.viewQueue.push(product)
      store.set("viewQueue", this.viewQueue)
   }

   lastProducts(n = 5) {
      let lastProducts
      lastProducts = _.reverse(this.viewQueue)
      lastProducts = _.uniq(lastProducts)
      lastProducts = _.reverse(lastProducts)
      lastProducts = _.takeRight(lastProducts, n + 1)
      return lastProducts
   }

}



// WEBPACK FOOTER //
// ./src/sdk/Analytics.js